// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React from 'react'
import { render } from 'react-dom'

import Routes from './routes'

render(
    <Routes />
    ,
    document.getElementById('root')
)


// WEBPACK FOOTER //
// ./src/index.js